import React from 'react';
import Link from 'next/link';
import PropTypes from 'prop-types';
import css from './_navbrand.module.scss';
import Image from 'next/image';

const Navbrand = (props) => {
  return (
    <Link className={`${css.nav__brand} ${props.styleOverwrite}`} href="/">
        <Image
          src={props.imgSrc}
          width={100}
          height={100}
          alt={props.imgDesc}
        />
    </Link>
  );
};

Navbrand.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  imgDesc: PropTypes.string
};

Navbrand.defaultProps = {
  imgSrc: "/static/images/logos/logo.webp",
  imgDesc: "Logo Mille et une listes"
};

export default Navbrand;
